export const CALL_SOURCE = {
  CALL_PANEL: 'call_panel',
  GLOT_SCENARIO: 'glot_scenario',
  GLOT_VOICE: 'glot_voice',
} as const;

export type CallSource = (typeof CALL_SOURCE)[keyof typeof CALL_SOURCE];

export const PLG_PENDO_EVENTS = {
  GLOT_SESSION_STARTED: 'glot_session_started',
  AGENT_CREATED_VIA_GLOT: 'agent_created_via_glot',
  GLOT_PROMPT_SENT: 'glot_prompt_sent',
  GLOT_PROMPT_FAILED: 'glot_prompt_failed',
  AGENT_MODIFIED_POST_GLOT: 'agent_modified_post_glot',
  PARAGON_INTEGRATION_CONNECTED: 'paragon_integration_connected',
  API_KEY_GENERATED: 'api_key_generated',
  POLYPHONE_PUBLISHED: 'polyphone_published',
  AGENT_SHARE_LINK_USED_EXTERNALLY: 'agent_share_link_used_externally',
  DEMO_REQUESTED_CLICK: 'demo_requested_click',
  PHONE_NUMBER_INTEREST_CLICK: 'phone_number_interest_click',
} as const;
